import React from 'react'

export default function MapIframe({width='100%', height='100%', src=''}) {
  return (
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.6173564335504!2d-73.98823932395293!3d40.748444535383804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sca!4v1682913080501!5m2!1sen!2sca"
        width={width}
        height={height}
        style={{ border: 'none' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  )
}
